import React from 'react';
import LoupeLogo from '../../../../../../../../svg/icons/loupe-logo.svg';
import styles from './logo.module.pcss';

function Logo(): React.ReactElement {
  return (
    <a href="/" className={styles.logo}>
      <div className={styles['logo__background-strip']} />
      <LoupeLogo className={styles.logo__icon} alt="logo" />
    </a>
  );
}

export default Logo;
